import 'rxjs'
import Raven from 'raven-js'

const MAX_PAYLOAD = 150

const pharosCrumbsEpic = (action$) =>
  action$
    .map((action) => {
      if (!Raven.isSetup()) {
        return
      }
      let payload
      try {
        payload = JSON.stringify(action.payload)
      } catch (e) {
        payload = e.message
      }
      if (payload && payload.length > MAX_PAYLOAD) {
        payload = payload.substr(0, MAX_PAYLOAD) + '...'
      }
      Raven.captureBreadcrumb({
        message: 'Redux ' + action.type,
        category: 'action',
        data: {
          payload,
        },
      })
      return null
    })
    .filter(() => false)

export default pharosCrumbsEpic
